import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// APP配置接口
enum API {
  // gsip
  Gsip = '/hk-web/gsip',
  // getRestrictedConfig
  PublicCommonLocales = '/hk-web/public/common/locales',
  // tradeMarkets
  MarketTradeAreas = '/hk-web/market/trade_areas',
  // 获取WEB配置信息
  PublicGetWebConfig = '/hk-web/public/get-web-config',
  // 获取Google分析配置
  PartnerGetGgaConfig = '/hk-web/partner/get-gga-config',
  // 获取KYC认证配置，version版本号，默认是0，1-20250110版本(AmlBot)
  PublicKycGetConfig = '/hk-web/public/kyc/get-config',
  // getRestrictedConfiglocales
  PublicLocales5g2et0FR = '/hk-web/public/locales/5g2et0FR',
  // 国家或地区与货币映射关系
  PublicLocalesFiats5g2et0FR = '/hk-web/public/locales/fiats/5g2et0FR',
  // 获取客服系统配置
  PublicServiceGetConfig = '/hk-web/public/service/get-config',
  // getConfig
  V2GetConfig = '/hk-web/v2/getConfig',
  // getV3Config
  V3GetConfig = '/hk-web/v3/getConfig',
}

export type TPostGsipParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostGsipResponse = TResponse<string>
export const postGsip = (params?: TPostGsipParams, options?: RequestOptions) => {
  return hcAxios.post<TPostGsipResponse>(API.Gsip, params, { options })
}

export type TGetPublicCommonLocalesParams = {
  scene?: any // scene
}
export type TGetPublicCommonLocalesResponse = TResponse<string[]>
export const getPublicCommonLocales = (params?: TGetPublicCommonLocalesParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPublicCommonLocalesResponse>(API.PublicCommonLocales, { params, options })
}

export type TGetMarketTradeAreasParams = any
export type TGetMarketTradeAreasResponse = TResponse<
  {
    brief?: string // 简短描述
    code?: number // 交易区编号
    hasNeed?: boolean // 交易区是否必须
    name?: string // 交易区名称
    sort?: number // 交易区排序id
    support?: string // 交易区支持的客户端列表
    topic?: string // 交易区主题
  }[]
>
export const getMarketTradeAreas = (params?: TGetMarketTradeAreasParams, options?: RequestOptions) => {
  return hcAxios.get<TGetMarketTradeAreasResponse>(API.MarketTradeAreas, { params, options })
}

export type TGetPublicGetWebConfigParams = {
  client?: any // client
  version?: any // version
}
export type TGetPublicGetWebConfigResponse = TResponse<{
  backupWebsites?: string[] // 备用域名列表
  officialWebsites?: string[] // 官方域名列表
  version?: string // 配置版本号
}>
export const getPublicGetWebConfig = (params?: TGetPublicGetWebConfigParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPublicGetWebConfigResponse>(API.PublicGetWebConfig, { params, options })
}

export type TPostMarketTradeAreasParams = any
export type TPostMarketTradeAreasResponse = TResponse<
  {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
>
export const postMarketTradeAreas = (params?: TPostMarketTradeAreasParams, options?: RequestOptions) => {
  return hcAxios.post<TPostMarketTradeAreasResponse>(API.MarketTradeAreas, params, { options })
}

export type TPutMarketTradeAreasParams = any
export type TPutMarketTradeAreasResponse = TResponse<
  {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
>
export const putMarketTradeAreas = (params?: TPutMarketTradeAreasParams, options?: RequestOptions) => {
  return hcAxios.put<TPutMarketTradeAreasResponse>(API.MarketTradeAreas, params, { options })
}

export type TDeleteMarketTradeAreasParams = any
export type TDeleteMarketTradeAreasResponse = TResponse<
  {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
>
export const deleteMarketTradeAreas = (params?: TDeleteMarketTradeAreasParams, options?: RequestOptions) => {
  return hcAxios.delete<TDeleteMarketTradeAreasResponse>(API.MarketTradeAreas, { params, options })
}

export type TPostPartnerGetGgaConfigParams = {
  icCode?: string
}
export type TPostPartnerGetGgaConfigResponse = TResponse<any>
export const postPartnerGetGgaConfig = (params?: TPostPartnerGetGgaConfigParams, options?: RequestOptions) => {
  return hcAxios.post<TPostPartnerGetGgaConfigResponse>(API.PartnerGetGgaConfig, params, { options })
}

export type TGetPublicKycGetConfigParams = {
  ver?: any // ver
}
export type TGetPublicKycGetConfigResponse = TResponse<{
  kycTypes?: number[]
}>
export const getPublicKycGetConfig = (params?: TGetPublicKycGetConfigParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPublicKycGetConfigResponse>(API.PublicKycGetConfig, { params, options })
}

export type TGetPublicLocales5g2et0FRParams = {
  address?: any // address
}
export type TGetPublicLocales5g2et0FRResponse = TResponse<any>
export const getPublicLocales5g2et0FR = (params?: TGetPublicLocales5g2et0FRParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPublicLocales5g2et0FRResponse>(API.PublicLocales5g2et0FR, { params, options })
}

export type TGetPublicLocalesFiats5g2et0FRParams = any
export type TGetPublicLocalesFiats5g2et0FRResponse = TResponse<any>
export const getPublicLocalesFiats5g2et0FR = (
  params?: TGetPublicLocalesFiats5g2et0FRParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetPublicLocalesFiats5g2et0FRResponse>(API.PublicLocalesFiats5g2et0FR, { params, options })
}

export type TGetPublicServiceGetConfigParams = any
export type TGetPublicServiceGetConfigResponse = TResponse<{
  kolIncentive?: boolean // KOL入口是否开启 true-开启 false-关闭
  serviceLines?: number[] // 客服系统线路配置
}>
export const getPublicServiceGetConfig = (params?: TGetPublicServiceGetConfigParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPublicServiceGetConfigResponse>(API.PublicServiceGetConfig, { params, options })
}

export type TGetV2GetConfigParams = any
export type TGetV2GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
}>
export const getV2GetConfig = (params?: TGetV2GetConfigParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV2GetConfigResponse>(API.V2GetConfig, { params, options })
}

export type TPostV2GetConfigParams = any
export type TPostV2GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
}>
export const postV2GetConfig = (params?: TPostV2GetConfigParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV2GetConfigResponse>(API.V2GetConfig, params, { options })
}

export type TPutV2GetConfigParams = any
export type TPutV2GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
}>
export const putV2GetConfig = (params?: TPutV2GetConfigParams, options?: RequestOptions) => {
  return hcAxios.put<TPutV2GetConfigResponse>(API.V2GetConfig, params, { options })
}

export type TDeleteV2GetConfigParams = any
export type TDeleteV2GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
}>
export const deleteV2GetConfig = (params?: TDeleteV2GetConfigParams, options?: RequestOptions) => {
  return hcAxios.delete<TDeleteV2GetConfigResponse>(API.V2GetConfig, { params, options })
}

export type TGetV3GetConfigParams = any
export type TGetV3GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  domain?: {
    analyticsUrl?: string
    chat?: string
    contract?: string
    h5I18n?: string
    h5domain?: string
    jpushLinkHost?: string
    jpushReport?: string
    klineHistory?: string
    officialWebsite?: string
    oss?: string
    otc?: string
    securityUpload?: string
    serviceFile?: string
    serviceHttp?: string
    stock?: string
    urls?: {
      curDefault?: boolean
      domain?: string
      domainId?: string
      port?: number
      supportHttpDNS?: boolean
    }[]
  }
  region?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
  wss?: {
    chatWss?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    contractPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    stockPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
  }
}>
export const getV3GetConfig = (params?: TGetV3GetConfigParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV3GetConfigResponse>(API.V3GetConfig, { params, options })
}

export type TPostV3GetConfigParams = any
export type TPostV3GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  domain?: {
    analyticsUrl?: string
    chat?: string
    contract?: string
    h5I18n?: string
    h5domain?: string
    jpushLinkHost?: string
    jpushReport?: string
    klineHistory?: string
    officialWebsite?: string
    oss?: string
    otc?: string
    securityUpload?: string
    serviceFile?: string
    serviceHttp?: string
    stock?: string
    urls?: {
      curDefault?: boolean
      domain?: string
      domainId?: string
      port?: number
      supportHttpDNS?: boolean
    }[]
  }
  region?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
  wss?: {
    chatWss?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    contractPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    stockPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
  }
}>
export const postV3GetConfig = (params?: TPostV3GetConfigParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3GetConfigResponse>(API.V3GetConfig, params, { options })
}

export type TPutV3GetConfigParams = any
export type TPutV3GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  domain?: {
    analyticsUrl?: string
    chat?: string
    contract?: string
    h5I18n?: string
    h5domain?: string
    jpushLinkHost?: string
    jpushReport?: string
    klineHistory?: string
    officialWebsite?: string
    oss?: string
    otc?: string
    securityUpload?: string
    serviceFile?: string
    serviceHttp?: string
    stock?: string
    urls?: {
      curDefault?: boolean
      domain?: string
      domainId?: string
      port?: number
      supportHttpDNS?: boolean
    }[]
  }
  region?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
  wss?: {
    chatWss?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    contractPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    stockPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
  }
}>
export const putV3GetConfig = (params?: TPutV3GetConfigParams, options?: RequestOptions) => {
  return hcAxios.put<TPutV3GetConfigResponse>(API.V3GetConfig, params, { options })
}

export type TDeleteV3GetConfigParams = any
export type TDeleteV3GetConfigResponse = TResponse<{
  BBOCalculatPercent?: string
  bbocalculatPercent?: string
  domain?: {
    analyticsUrl?: string
    chat?: string
    contract?: string
    h5I18n?: string
    h5domain?: string
    jpushLinkHost?: string
    jpushReport?: string
    klineHistory?: string
    officialWebsite?: string
    oss?: string
    otc?: string
    securityUpload?: string
    serviceFile?: string
    serviceHttp?: string
    stock?: string
    urls?: {
      curDefault?: boolean
      domain?: string
      domainId?: string
      port?: number
      supportHttpDNS?: boolean
    }[]
  }
  region?: string
  tradeArea?: {
    brief?: string
    code?: number
    hasNeed?: boolean
    name?: string
    sort?: number
    support?: string
    topic?: string
  }[]
  version?: string
  wss?: {
    chatWss?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    contractPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
    stockPush?: {
      path?: string
      urls?: {
        curDefault?: boolean
        domain?: string
        domainId?: string
        port?: number
        supportHttpDNS?: boolean
      }[]
    }
  }
}>
export const deleteV3GetConfig = (params?: TDeleteV3GetConfigParams, options?: RequestOptions) => {
  return hcAxios.delete<TDeleteV3GetConfigResponse>(API.V3GetConfig, { params, options })
}
